module.exports = __webpack_public_path__ + "img/qrcode.8addb0e3.svg";